
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
// Import music files so Parcel bundles them (url: prefix for static assets)
var $7eaaceaa7001974d$exports = {};
$7eaaceaa7001974d$exports = import.meta.resolve("4ANB2");


var $0e91789fa306421c$exports = {};
$0e91789fa306421c$exports = import.meta.resolve("2WNIc");


var $cf0f0f6c48ea2cd9$exports = {};
$cf0f0f6c48ea2cd9$exports = import.meta.resolve("jt9yT");


var $c77aa062b2f57e44$exports = {};
$c77aa062b2f57e44$exports = import.meta.resolve("a1F3z");


var $010a20cdc149de43$exports = {};
$010a20cdc149de43$exports = import.meta.resolve("79er3");


var $c4b84eb1cba05d9b$exports = {};
$c4b84eb1cba05d9b$exports = import.meta.resolve("iOrmm");


var $f6d92db487a7fe48$exports = {};
$f6d92db487a7fe48$exports = import.meta.resolve("hzefs");


var $d880e749316c6cbb$exports = {};
$d880e749316c6cbb$exports = import.meta.resolve("9afzA");


var $a23a18d9583fbb40$exports = {};
$a23a18d9583fbb40$exports = import.meta.resolve("sAJbF");


document.addEventListener('DOMContentLoaded', function() {
    // ==========================================
    // Music Player
    // ==========================================
    const musicPlayer = document.getElementById('music-player');
    const audioPlayer = document.getElementById('audio-player');
    const albumArt = document.getElementById('album-art');
    const songTitle = document.getElementById('song-title');
    const playPauseBtn = document.getElementById('play-pause-btn');
    const prevBtn = document.getElementById('prev-btn');
    const nextBtn = document.getElementById('next-btn');
    const muteBtn = document.getElementById('mute-btn');
    // Only initialize music player if elements exist
    if (musicPlayer && playPauseBtn && muteBtn) {
        const playIcon = playPauseBtn.querySelector('.play-icon');
        const pauseIcon = playPauseBtn.querySelector('.pause-icon');
        const unmutedIcon = muteBtn.querySelector('.unmuted-icon');
        const mutedIcon = muteBtn.querySelector('.muted-icon');
        // Spotify link element
        const spotifyLink = document.getElementById('spotify-link');
        // Song library - using imported files
        const songs = [
            {
                title: 'GROUP CHAT',
                artist: 'HODLBOYZ',
                src: (0, (/*@__PURE__*/$parcel$interopDefault($7eaaceaa7001974d$exports))),
                art: (0, (/*@__PURE__*/$parcel$interopDefault($a23a18d9583fbb40$exports))),
                spotify: 'https://www.youtube.com/watch?v=Wilxvlt5fBY&list=PL48yEe7Mo2cNH2Z6NG3aOQu-SFWzi8_yh&index=1'
            },
            {
                title: 'PRE RICH',
                artist: 'HODLBOYZ',
                src: (0, (/*@__PURE__*/$parcel$interopDefault($0e91789fa306421c$exports))),
                art: (0, (/*@__PURE__*/$parcel$interopDefault($a23a18d9583fbb40$exports))),
                spotify: 'https://www.youtube.com/watch?v=ibH0gf0gUeA&list=PL48yEe7Mo2cNH2Z6NG3aOQu-SFWzi8_yh&index=2'
            },
            {
                title: 'WIFE CHANGING MONEY',
                artist: 'HODLBOYZ',
                src: (0, (/*@__PURE__*/$parcel$interopDefault($cf0f0f6c48ea2cd9$exports))),
                art: (0, (/*@__PURE__*/$parcel$interopDefault($a23a18d9583fbb40$exports))),
                spotify: 'https://www.youtube.com/watch?v=78gKHaT8J0Y&list=PL48yEe7Mo2cNH2Z6NG3aOQu-SFWzi8_yh&index=3'
            },
            {
                title: 'BAG TALK',
                artist: 'HODLBOYZ',
                src: (0, (/*@__PURE__*/$parcel$interopDefault($c77aa062b2f57e44$exports))),
                art: (0, (/*@__PURE__*/$parcel$interopDefault($a23a18d9583fbb40$exports))),
                spotify: 'https://www.youtube.com/watch?v=d9ajSFBMUdo&list=PL48yEe7Mo2cNH2Z6NG3aOQu-SFWzi8_yh&index=4'
            },
            {
                title: 'LIQUIDATED',
                artist: 'HODLBOYZ',
                src: (0, (/*@__PURE__*/$parcel$interopDefault($010a20cdc149de43$exports))),
                art: (0, (/*@__PURE__*/$parcel$interopDefault($a23a18d9583fbb40$exports))),
                spotify: 'https://www.youtube.com/watch?v=4qisDFInsKU&list=PL48yEe7Mo2cNH2Z6NG3aOQu-SFWzi8_yh&index=5'
            },
            {
                title: 'CRASHOUT',
                artist: 'HODLBOYZ',
                src: (0, (/*@__PURE__*/$parcel$interopDefault($c4b84eb1cba05d9b$exports))),
                art: (0, (/*@__PURE__*/$parcel$interopDefault($a23a18d9583fbb40$exports))),
                spotify: 'https://www.youtube.com/watch?v=cp-IezIXDb4&list=PL48yEe7Mo2cNH2Z6NG3aOQu-SFWzi8_yh&index=6'
            },
            {
                title: 'TOUCH GRASS',
                artist: 'HODLBOYZ',
                src: (0, (/*@__PURE__*/$parcel$interopDefault($f6d92db487a7fe48$exports))),
                art: (0, (/*@__PURE__*/$parcel$interopDefault($a23a18d9583fbb40$exports))),
                spotify: 'https://www.youtube.com/watch?v=Loax_cpiIoI&list=PL48yEe7Mo2cNH2Z6NG3aOQu-SFWzi8_yh&index=8'
            },
            {
                title: 'MR RUN IT BACK',
                artist: 'HODLBOYZ',
                src: (0, (/*@__PURE__*/$parcel$interopDefault($d880e749316c6cbb$exports))),
                art: (0, (/*@__PURE__*/$parcel$interopDefault($a23a18d9583fbb40$exports))),
                spotify: 'https://www.youtube.com/watch?v=vwCTKvtJLC8&list=PL48yEe7Mo2cNH2Z6NG3aOQu-SFWzi8_yh&index=9'
            }
        ];
        let currentSongIndex = 0;
        let isPlaying = false;
        let isMuted = false;
        // Load song
        function loadSong(index) {
            const song = songs[index];
            audioPlayer.src = song.src;
            audioPlayer.load();
            albumArt.src = song.art;
            songTitle.textContent = song.title;
            if (spotifyLink) spotifyLink.href = song.spotify;
        }
        // Play song
        function playSong() {
            const playPromise = audioPlayer.play();
            if (playPromise !== undefined) playPromise.then(()=>{
                isPlaying = true;
                playIcon.style.display = 'none';
                pauseIcon.style.display = 'block';
            }).catch((error)=>{
                console.log('Play was prevented:', error);
                isPlaying = false;
            });
        }
        // Pause song
        function pauseSong() {
            audioPlayer.pause();
            isPlaying = false;
            playIcon.style.display = 'block';
            pauseIcon.style.display = 'none';
        }
        // Previous song
        function prevSong() {
            currentSongIndex--;
            if (currentSongIndex < 0) currentSongIndex = songs.length - 1;
            loadSong(currentSongIndex);
            if (isPlaying) playSong();
        }
        // Next song
        function nextSong() {
            currentSongIndex++;
            if (currentSongIndex >= songs.length) currentSongIndex = 0;
            loadSong(currentSongIndex);
            if (isPlaying) playSong();
        }
        // Toggle mute
        function toggleMute() {
            isMuted = !isMuted;
            audioPlayer.muted = isMuted;
            if (isMuted) {
                unmutedIcon.style.display = 'none';
                mutedIcon.style.display = 'block';
            } else {
                unmutedIcon.style.display = 'block';
                mutedIcon.style.display = 'none';
            }
        }
        // Event listeners
        playPauseBtn.addEventListener('click', ()=>{
            if (isPlaying) pauseSong();
            else playSong();
        });
        prevBtn.addEventListener('click', prevSong);
        nextBtn.addEventListener('click', nextSong);
        muteBtn.addEventListener('click', toggleMute);
        // Auto play next song when current ends
        audioPlayer.addEventListener('ended', nextSong);
        // Initialize first song
        loadSong(currentSongIndex);
        // ==========================================
        // Draggable Music Player (desktop only)
        // ==========================================
        let isDragging = false;
        let dragStartX, dragStartY;
        let playerStartX, playerStartY;
        // Only enable dragging on desktop
        const isMobile = ()=>window.innerWidth <= 768;
        musicPlayer.addEventListener('mousedown', startDrag);
        // Disable touch dragging on mobile
        musicPlayer.addEventListener('touchstart', (e)=>{
            if (!isMobile()) startDrag(e);
        }, {
            passive: true
        });
        function startDrag(e) {
            // Don't drag on mobile or if clicking on controls
            if (isMobile()) return;
            if (e.target.closest('.control-btn')) return;
            if (e.target.closest('.spotify-link')) return;
            isDragging = true;
            musicPlayer.style.cursor = 'grabbing';
            const clientX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
            const clientY = e.type === 'touchstart' ? e.touches[0].clientY : e.clientY;
            dragStartX = clientX;
            dragStartY = clientY;
            const rect = musicPlayer.getBoundingClientRect();
            playerStartX = rect.left;
            playerStartY = rect.top;
            // Remove right/bottom positioning, switch to left/top
            musicPlayer.style.right = 'auto';
            musicPlayer.style.bottom = 'auto';
            musicPlayer.style.left = playerStartX + 'px';
            musicPlayer.style.top = playerStartY + 'px';
            document.addEventListener('mousemove', drag);
            document.addEventListener('touchmove', drag, {
                passive: false
            });
            document.addEventListener('mouseup', stopDrag);
            document.addEventListener('touchend', stopDrag);
            e.preventDefault();
        }
        function drag(e) {
            if (!isDragging) return;
            const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
            const clientY = e.type === 'touchmove' ? e.touches[0].clientY : e.clientY;
            const deltaX = clientX - dragStartX;
            const deltaY = clientY - dragStartY;
            let newX = playerStartX + deltaX;
            let newY = playerStartY + deltaY;
            // Keep within viewport bounds
            const rect = musicPlayer.getBoundingClientRect();
            const maxX = window.innerWidth - rect.width;
            const maxY = window.innerHeight - rect.height;
            newX = Math.max(0, Math.min(newX, maxX));
            newY = Math.max(0, Math.min(newY, maxY));
            musicPlayer.style.left = newX + 'px';
            musicPlayer.style.top = newY + 'px';
            e.preventDefault();
        }
        function stopDrag() {
            isDragging = false;
            musicPlayer.style.cursor = 'grab';
            document.removeEventListener('mousemove', drag);
            document.removeEventListener('touchmove', drag);
            document.removeEventListener('mouseup', stopDrag);
            document.removeEventListener('touchend', stopDrag);
        }
    } // End music player if block
    // ==========================================
    // Logo refresh
    // ==========================================
    const logoLink = document.querySelector('.logo-refresh');
    if (logoLink) logoLink.addEventListener('click', (e)=>{
        e.preventDefault();
        window.location.reload();
    });
    // ==========================================
    // Scroll to top for Home links
    // ==========================================
    const homeLinks = document.querySelectorAll('a[href="#"]:not(.logo-refresh)');
    homeLinks.forEach((link)=>{
        link.addEventListener('click', (e)=>{
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    });
    // ==========================================
    // Mobile Menu
    // ==========================================
    const menuTrigger = document.getElementById('mobile-menu-trigger');
    const mobileNav = document.querySelector('.mobile-nav');
    const header = document.querySelector('header');
    if (menuTrigger && mobileNav && header) {
        let isMenuOpen = false;
        function toggleMenu(open) {
            isMenuOpen = open;
            menuTrigger.classList.toggle('active', open);
            menuTrigger.setAttribute('aria-expanded', open);
            // Add/remove 'active' class to header
            header.classList.toggle('active', open);
            if (open) {
                document.body.style.overflow = 'hidden';
                document.documentElement.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
                document.body.style.height = '';
                document.documentElement.style.overflow = '';
                document.documentElement.style.height = '';
            }
        }
        menuTrigger.addEventListener('click', function(e) {
            e.preventDefault();
            toggleMenu(!isMenuOpen);
        });
        // Close menu when clicking on nav links
        const navLinks = mobileNav.querySelectorAll('a');
        navLinks.forEach((link)=>{
            link.addEventListener('click', ()=>{
                toggleMenu(false);
            });
        });
        // Close menu when clicking outside
        document.addEventListener('click', function(e) {
            if (isMenuOpen && !mobileNav.contains(e.target) && !menuTrigger.contains(e.target)) toggleMenu(false);
        });
        // Handle window resize
        window.addEventListener('resize', ()=>{
            if (window.innerWidth > 768) {
                document.body.style.removeProperty('overflow');
                document.body.style.removeProperty('height');
                document.documentElement.style.removeProperty('overflow');
                document.documentElement.style.removeProperty('height');
                menuTrigger.classList.remove('active');
                header.classList.remove('active');
                isMenuOpen = false;
            }
        });
    }
    // ==========================================
    // Spotify Carousel
    // ==========================================
    const carouselTrack = document.querySelector('.carousel-track');
    const carouselPrevBtn = document.querySelector('.carousel-prev');
    const carouselNextBtn = document.querySelector('.carousel-next');
    const carouselWrapper = document.querySelector('.carousel-wrapper');
    if (carouselTrack && carouselPrevBtn && carouselNextBtn) {
        let currentScroll = 0;
        let isCarouselDragging = false;
        let carouselStartX = 0;
        let carouselScrollLeft = 0;
        // Update arrow states based on scroll position
        function updateArrowStates() {
            // Calculate max scroll based on actual content width
            const cards = carouselTrack.querySelectorAll('.carousel-card');
            if (cards.length === 0) return;
            const firstCard = cards[0];
            const cardWidth = firstCard.offsetWidth;
            const gap = window.innerWidth <= 768 ? 16 : 24;
            const visibleCards = Math.floor(carouselTrack.clientWidth / (cardWidth + gap));
            const totalCards = cards.length;
            const maxScroll = Math.max(0, (totalCards - visibleCards) * (cardWidth + gap));
            // Disable prev button at start
            if (currentScroll <= 0) carouselPrevBtn.disabled = true;
            else carouselPrevBtn.disabled = false;
            // Disable next button at end (with small tolerance for rounding)
            if (currentScroll >= maxScroll - 5) carouselNextBtn.disabled = true;
            else carouselNextBtn.disabled = false;
        }
        // Scroll carousel
        function scrollCarousel(direction) {
            // Get the actual card width for responsive scrolling
            const cards = carouselTrack.querySelectorAll('.carousel-card');
            const firstCard = cards[0];
            const cardWidth = firstCard ? firstCard.offsetWidth : 280;
            const gap = window.innerWidth <= 768 ? 16 : 24; // Match SCSS breakpoint
            const scrollAmount = cardWidth + gap;
            if (direction === 'next') currentScroll += scrollAmount;
            else currentScroll -= scrollAmount;
            // Clamp scroll position - calculate based on actual content
            const visibleCards = Math.floor(carouselTrack.clientWidth / (cardWidth + gap));
            const totalCards = cards.length;
            const maxScroll = Math.max(0, (totalCards - visibleCards) * (cardWidth + gap));
            currentScroll = Math.max(0, Math.min(currentScroll, maxScroll));
            carouselTrack.style.transform = `translateX(-${currentScroll}px)`;
            updateArrowStates();
        }
        // Arrow button handlers
        carouselPrevBtn.addEventListener('click', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            scrollCarousel('prev');
        });
        carouselNextBtn.addEventListener('click', (e)=>{
            e.preventDefault();
            e.stopPropagation();
            scrollCarousel('next');
        });
        // Touch/swipe functionality (mobile only)
        function startCarouselDrag(e) {
            // Only enable drag on touch devices
            if (!e.type.includes('touch')) return;
            isCarouselDragging = true;
            carouselStartX = e.touches[0].pageX;
            carouselScrollLeft = currentScroll;
        }
        function carouselDrag(e) {
            if (!isCarouselDragging) return;
            e.preventDefault();
            const x = e.touches[0].pageX;
            const walk = carouselStartX - x;
            currentScroll = carouselScrollLeft + walk;
            // Clamp scroll position - calculate based on actual content
            const cards = carouselTrack.querySelectorAll('.carousel-card');
            const firstCard = cards[0];
            const cardWidth = firstCard ? firstCard.offsetWidth : 280;
            const gap = window.innerWidth <= 768 ? 16 : 24;
            const visibleCards = Math.floor(carouselTrack.clientWidth / (cardWidth + gap));
            const totalCards = cards.length;
            const maxScroll = Math.max(0, (totalCards - visibleCards) * (cardWidth + gap));
            currentScroll = Math.max(0, Math.min(currentScroll, maxScroll));
            carouselTrack.style.transform = `translateX(-${currentScroll}px)`;
            updateArrowStates();
        }
        function stopCarouselDrag() {
            isCarouselDragging = false;
        }
        // Touch events only (for mobile/tablet)
        carouselWrapper.addEventListener('touchstart', startCarouselDrag, {
            passive: false
        });
        document.addEventListener('touchmove', carouselDrag, {
            passive: false
        });
        document.addEventListener('touchend', stopCarouselDrag);
        // Prevent card clicks during touch drag
        let touchStartX = 0;
        carouselTrack.addEventListener('touchstart', (e)=>{
            touchStartX = e.touches[0].pageX;
        });
        carouselTrack.addEventListener('click', (e)=>{
            // Prevent clicks if touch moved significantly
            if (isCarouselDragging || Math.abs(touchStartX - carouselStartX) > 5) e.preventDefault();
        });
        // Initialize arrow states on load and resize
        function initCarousel() {
            // Wait for images to load for accurate measurements
            setTimeout(()=>{
                updateArrowStates();
            }, 100);
        }
        initCarousel();
        window.addEventListener('resize', initCarousel);
        updateArrowStates();
        // Update on window resize
        window.addEventListener('resize', updateArrowStates);
    }
    // ==========================================
    // Video Carousel
    // ==========================================
    const videoSlides = document.querySelectorAll('.video-slide');
    const videoPrevBtns = document.querySelectorAll('.video-arrow-prev');
    const videoNextBtns = document.querySelectorAll('.video-arrow-next');
    if (videoSlides.length > 0 && videoPrevBtns.length > 0 && videoNextBtns.length > 0) {
        let currentVideoIndex = 0;
        // Update video carousel display
        function updateVideoCarousel() {
            videoSlides.forEach((slide, index)=>{
                const isActive = index === currentVideoIndex;
                slide.classList.toggle('active', isActive);
                // Pause video when slide becomes inactive
                const video = slide.querySelector('video');
                if (video && !isActive) video.pause();
            });
            // Update arrow states for all buttons
            const isFirst = currentVideoIndex === 0;
            const isLast = currentVideoIndex === videoSlides.length - 1;
            videoPrevBtns.forEach((btn)=>{
                btn.disabled = isFirst;
            });
            videoNextBtns.forEach((btn)=>{
                btn.disabled = isLast;
            });
        }
        // Previous video - attach to all prev buttons
        videoPrevBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                if (currentVideoIndex > 0) {
                    currentVideoIndex--;
                    updateVideoCarousel();
                }
            });
        });
        // Next video - attach to all next buttons
        videoNextBtns.forEach((btn)=>{
            btn.addEventListener('click', ()=>{
                if (currentVideoIndex < videoSlides.length - 1) {
                    currentVideoIndex++;
                    updateVideoCarousel();
                }
            });
        });
        // Initialize
        updateVideoCarousel();
    }
    // ==========================================
    // Video Play Overlay Buttons
    // ==========================================
    const playOverlays = document.querySelectorAll('.video-play-overlay');
    playOverlays.forEach((overlay)=>{
        overlay.addEventListener('click', function() {
            const videoWrapper = this.closest('.video-wrapper');
            const video = videoWrapper.querySelector('video');
            if (video) {
                video.play();
                // Fade out the play overlay
                this.classList.add('hidden');
            }
        });
    });
    // Show play overlay again when video is paused or ended
    videoSlides.forEach((slide)=>{
        const video = slide.querySelector('video');
        const overlay = slide.querySelector('.video-play-overlay');
        if (video && overlay) {
            video.addEventListener('pause', ()=>{
                if (!video.ended) overlay.classList.remove('hidden');
            });
            video.addEventListener('ended', ()=>{
                overlay.classList.remove('hidden');
            });
        }
    });
});


//# sourceMappingURL=hodl-boyz.51d06a91.js.map
